import {
  getColorArray,
} from '../tools/services/colors'

import {
  buildStyleFromLiteral,
} from '../tools/services/styles-literal'

export default function ({ fillColor = [255, 255, 255, 0.4], borderColor = [51, 153, 204, 1], borderWidth = 1 }) {
  return buildStyleFromLiteral({
    fill: {
      color: getColorArray(fillColor),
    },
    stroke: {
      color: getColorArray(borderColor),
      width: borderWidth,
    },
  })
}
